/**
 * Typ nástroje zobrazovače mapy.
 */
export enum ViewerToolType {
    /**
     * Získání aktuální pozice pomocí geolokace.
     *
     * Získaná pozice je vyznačena do mapy v podobě markeru
     * a je provedeno vycentrování na tuto pozici.
     */
    GEOLOCATION = 'GEOLOCATION',

    /**
     * Vytvoření nového objektu na mapě.
     *
     * Vyvolá událost {@link ViewerNewObjectEvent}. Pokud byl nástroj vyvolán skrze
     * kontextové menu, bude událost obsahovat souřadnice kurzoru na mapě.
     * V opačném případě budou souřadnice odpovídat centru mapy.
     */
    NEW_OBJECT = 'NEW_OBJECT',

    /**
     * Výběr features zákresem polygonu.
     *
     * Po dokončení výběru je vyvolána událost {@link ViewerSelectFeaturesEvent},
     */
    SELECT_FEATURES = 'SELECT_FEATURES',

    /**
     * Měření vzdálenosti zakreslením čáry.
     */
    MEASURE_LINE = 'MEASURE_LINE',

    /**
     * Měření plochy zakreslením polygonu.
     */
    MEASURE_POLYGON = 'MEASURE_POLYGON',
}
